/**
 * ボーダーのスタイル指定
 * @param color ボーダー色
 * @param width ボーダーの幅
 * @param style ボーダーの線種
 * @returns ボーダーのスタイル
 */
export function borderStyle(color, width, style) {
    if (style === void 0) { style = 'solid'; }
    return width + "px " + style + " " + color;
}
